import { render } from "./PricingTableModal.vue?vue&type=template&id=fb24f8f0&scoped=true"
import script from "./PricingTableModal.vue?vue&type=script&lang=js"
export * from "./PricingTableModal.vue?vue&type=script&lang=js"

import "./PricingTableModal.vue?vue&type=style&index=0&id=fb24f8f0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb24f8f0"]])

export default __exports__